import {computedAsync, useMemoize} from '@vueuse/core';
import {defineStore, storeToRefs} from 'pinia';
import type {ResourceType} from '../../api/models/booking/resourceModel';
import {useUserStore} from '../userStore';
import {getResourceTypes} from '../../api/repositories/booking/ResourceRepository';
import {useLocaleStore} from '../localeStore';
import {computed} from 'vue';
import {toRecord} from '../../shared/helpers/arrayHelper';

export const useResourceTypeStore = defineStore('resourceType', () => {
    const {user, isAuthenticated} = storeToRefs(useUserStore());
    const {currentLocale} = storeToRefs(useLocaleStore());

    const getResourceTypesMemoized = useMemoize((_userId: string, _currentLocale: string) =>
        getResourceTypes()
    );

    const resourceTypes = computedAsync<ResourceType[]>(() => {
        if (!isAuthenticated.value || !user.value?.id) {
            return [];
        }
        return getResourceTypesMemoized(user.value.id, currentLocale.value);
    }, []);

    const resourceTypesMap = computed(() =>
        toRecord(resourceTypes.value, resourceType => resourceType.id)
    );

    return {resourceTypes, resourceTypesMap};
});
